import styled from "styled-components";

export const StyledCaptcha = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 5px;
  gap: 10px;
  align-items: center;
`;
